import React, { useEffect } from "react";
import { formatDateDutch } from "../../utils/formatDateDutch";
import clock_black from "../../assets/clock_black.svg";
import clock_pink from "../../assets/clock_pink.svg";
// import { disableEnableTimeslot } from "../../redux/actions/timeslot";
import { useDispatch, useSelector } from "react-redux";
import { extractTimeRange } from "../../utils/extractTimeRange";
import { generateUniqueId } from "../../utils/generateUniqueId";
import { formatDutchDate } from "../../utils/formatDutchDate";
import Calendar from "react-calendar";
import Loader from "../Loader";
import StepsDisplay from "../StepsDisplay";
import { useSearchParams } from "react-router-dom";
import { fetchAllOrders } from "../../redux/actions/orders";

const StepOne = ({
  date,
  data,
  setInputHandle,
  nextStep,
  progressWidth,
  step,
  setDate,
}) => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { data: appointments, loading } = useSelector(
    (state) => state.appointments
  );

  const { orders } = useSelector((state) => state.allOrder);

  useEffect(() => {
    dispatch(fetchAllOrders());
  }, [dispatch]);

  const selectedDate = formatDateDutch(date).split(",")[0].trim();
  const dataAsPerSelectedDate = data.filter((item) =>
    item.text.includes(selectedDate)
  );

  const appointmentData = (ids) => {
    if (!ids) return [];
    if (Array.isArray(ids)) {
      return appointments.filter((item) => ids.includes(item.id));
    } else {
      return appointments.filter((item) => item.id === ids);
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="right">
      <div className="calender_container">
        <h3 className="georgia-font fw-bold">Kies je datum & tijd</h3>
        <Calendar className="calender" onChange={setDate} value={date} />
        <div className="calender_text">
          <img
            src="/images/icon-globe.svg"
            alt="Icon globe"
            width="16"
            height="16"
          />
          <p>UTC+1, Time Zone | Europe/Amsterdam</p>
        </div>
      </div>
      <div className="timetable">
        <div className="top_header">
          <h5 className="fw-600">{formatDateDutch(date)}</h5>
          <StepsDisplay progressWidth={progressWidth} step={step} />
        </div>

        <div className="right_content">
          <ul className="list-unstyled d-flex flex-column gap-3">
            {dataAsPerSelectedDate.map((item) => {
              const startTime = item.text.split("-")[1].trim();

              const appointmentDataFound = appointmentData(
                item.appointment
              ).filter(
                (a) =>
                  formatDutchDate(a.appointmentDate) ===
                    formatDateDutch(date) && a.timeslot === item.text
              ).filter((appt) => appt.paymentStatus === "paid")[0];
              const isPaid =
                orders.filter(
                  (order) =>
                    order.id === appointmentDataFound?.invoiceNumber
                ).length > 0
              const isDisabled = item.dates?.includes(formatDateDutch(date));
              const isTodaysApp =
                appointmentDataFound &&
                formatDutchDate(appointmentDataFound?.appointmentDate) ===
                  formatDateDutch(date) &&
                isPaid;

              return (
                <li
                  className={`appointment_container ${
                    isTodaysApp || isDisabled ? "appointment_exist" : ""
                  } d-flex justify-content-between align-items-center p-3`}
                  key={item.id}
                >
                  <div className="d-flex align-items-center gap-3 w-50">
                    {isTodaysApp || isDisabled ? (
                      <img src={clock_pink} alt="" />
                    ) : (
                      <img src={clock_black} alt="" />
                    )}
                    <h5
                      className={`${
                        isTodaysApp || isDisabled ? "bezet_time" : ""
                      } fw-600 mb-0`}
                    >
                      {startTime} uur
                    </h5>
                  </div>

                  <div className="actions">
                    {isTodaysApp || isDisabled ? (
                      <button className="bezet">Bezet</button>
                    ) : (
                      <button
                        onClick={() => {
                          setInputHandle((prev) => {
                            const orderIdEncoded = searchParams.get("oi");
                            let orderId;
                            if (orderIdEncoded) {
                              orderId = atob(orderIdEncoded);
                            }

                            return {
                              ...prev,
                              appointmentTime: extractTimeRange(item.text),
                              invoiceNumber: orderId || generateUniqueId(),
                            };
                          });
                          nextStep();
                        }}
                        className="planin"
                      >
                        Inplannen
                      </button>
                    )}
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default StepOne;
